import moment from 'moment'

function parse (dateString) {
    return dateString ? moment(dateString).toDate() : null
}
function format (value, formatType) {
    return moment(value).format(formatType)
}

function formatForSearch (date) {
    return date ? moment(date).format('YYYY-MM-DD') : null
}

function getDayOfWeek (offset) {
    return moment()
        .day(offset)
        .toDate()
}

function getDayFromToday (offset) {
    return moment()
        .add(offset, 'day')
        .toDate()
}

function getRange (key) {
    let from = null
    let to = null
    switch (key) {
    case 'today':
        from = new Date()
        to = from
        break
    case 'tomorrow':
        from = getDayFromToday(1)
        to = from
        break
    case 'weekend':
        from = getDayOfWeek(5)
        to = getDayOfWeek(7)
        break
    default:
        break
    }
    return from && to ? [from, to] : null
}

function getYearsDifference (date1, date2) {
    if (!moment.isDate(date1)) {
        throw new Error('Invalid Argument: `date1` must be a Date instance.')
    }
    if (!moment.isDate(date2)) {
        throw new Error('Invalid Argument: `date2` must be a Date instance.')
    }
    return moment(date1).year() - moment(date2).year()
}

function areDatesEqual (date1, date2) {
    return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
    )
}

export default {
    moment,
    parse,
    format,
    formatForSearch,
    getDayOfWeek,
    getDayFromToday,
    getRange,
    getYearsDifference,
    areDatesEqual
}
